<template lang="html">
  <div class="faq-wrapper-background">
    <div class="page-help content">
      <h1 class="title">{{ $t("nav.faq") }}</h1>
      <div class="faq-wrapper">
        <div v-for="(faq, index) in list" :key="index" class="faq">
          <div @click="faq.open = !faq.open" class="faq-question">
            <div class="icon-wrapper">
              <img
                :class="{ openImg: faq.open }"
                src="@/assets/newImges/Chevron.svg"
                alt="open faq icon"
              />
              <!-- <img
                v-if="!faq.open"
                src="@/assets/icons/plus.png"
                alt="open faq icon"
              />
              <img
                v-else
                src="@/assets/icons/minus.png"
                class="minus-icon"
                alt="open faq icon"
              /> -->
            </div>
            <span v-html="faq.question"></span>
          </div>
          <div v-if="faq.open" class="faq-answer" v-html="faq.answer"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/api";
export default {
  name: "Faq",
  data() {
    return {
      list: []
    };
  },
  mounted() {
    this.getFaqs();
  },
  methods: {
    getFaqs() {
      api
        .getFaqs()
        .then(res => {
          console.log(res.data.data);
          for (var i = 0; i < res.data.data.length; i++) {
            res.data.data[i].open = false;
          }
          this.list = res.data.data;
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  watch: {
    "$route.params.lang": {
      handler: function() {
        this.getFaqs();
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.faq-wrapper-background {
  background-color: $gray-blue-100;
  padding-top: 113px;
  padding-bottom: 204px;
  width: 100%;
  text-align: left;
  font-family: Outfit;
  .title {
    font-weight: 600;
    font-style: SemiBold;
    font-size: 36px;
    line-height: 66px;
    letter-spacing: 0%;
    margin: 0;
    margin-bottom: 85px;
  }

  .faq-wrapper {
    display: flex;
    flex-direction: column;

    .faq {
      font-family: Outfit;
      min-height: 104px;
      border: 2px solid $gray-blue-700;
      border-radius: 10px;
      margin-bottom: 30px;
      background-color: $gray-blue-100;

      .faq-question {
        font-weight: 400;
        font-style: Regular;
        font-size: 25px;
        line-height: 100%;
        letter-spacing: 0%;

        color: $blue-1000;
        height: 104px;
        display: flex;
        align-items: center;
        cursor: pointer;
        padding: 0 24px;

        .icon-wrapper {
          height: 56px !important;
          img {
            transition: 0.3s;
          }
          .openImg {
            transform: rotate(90deg);
          }
        }
      }
      .faq-answer {
        font-weight: 400;
        font-style: Regular;
        font-size: 20px;
        line-height: 30px;
        letter-spacing: 0%;
        color: $blue-400;

        margin-bottom: 30px;
        padding-left: 80px;
        padding-right: 10px;
      }
      .ul {
        margin: 0;
        padding: 0;
        .line {
          display: inline-block;
          text-decoration: underline !important;
          text-decoration-line: underline;
          color: red;
        }
      }
      .ul li {
        padding: 1.4% 0;
        margin-left: 0;
      }
    }
  }
}
@media only screen and (max-width: 768px) {
  .faq-wrapper-background {
    padding-top: 63px;
    padding-bottom: 84px;
    .title {
      font-size: 26px;
      line-height: 36px;

      margin-bottom: 45px;
    }
    .faq-wrapper {
      .faq {
        min-height: 90px;
        margin-bottom: 20px;
        .faq-question {
          font-size: 20px;
          text-align: left;
          height: 90px;
          padding: 0 16px 0 0;

          .icon-wrapper {
            .minus-icon {
              margin-bottom: 5px;
            }
          }
        }
        .faq-answer {
          font-size: 16px;
          line-height: 24px;

          margin-bottom: 30px;
          padding-left: 56px;
        }
      }
    }
  }
}
@media only screen and (max-width: 430px) {
  .faq-wrapper-background {
    .faq-wrapper {
      // padding: 35px 20px;
      .faq {
        margin-bottom: 15px;
        min-height: fit-content;
        padding: 5px;
        .faq-question {
          height: fit-content;
          cursor: pointer;
          font-size: 16px;
          .icon-wrapper {
            width: 30px;
            padding-right: 5px;
            img {
              margin-left: -15px;
            }

            .minus-icon {
              margin-bottom: 5px;
            }
          }
        }
        .faq-answer {
          font-size: 14px;
          padding-left: 36px;
        }
      }
    }
  }
}
</style>
